import {Component, Input} from '@angular/core';
import {NgIcon} from "@ng-icons/core";
import {RouterLink} from "@angular/router";
import {Place} from "@app/interfaces";
import {IonCard, IonCardContent} from "@ionic/angular/standalone";

@Component({
  selector: 'app-simple-place-card',
  templateUrl: './simple-place-card.component.html',
  styleUrls: ['./simple-place-card.component.scss'],
  imports: [
    NgIcon,
    RouterLink,
    IonCard,
    IonCardContent
  ]
})
export class SimplePlaceCardComponent {

  @Input() public place: Place | undefined;

  constructor() {
  }

}
